// 指标类型映射配置
// 用于将 uniapp 的 type 参数映射到指标类型和字段映射

/**
 * 指标类型编号到指标类型名称的映射
 */
export const INDICATOR_TYPE_NUMBER_MAP = {
  1: 'eye',           // 眼部
  2: 'skin',          // 皮肤
  3: 'breathing',     // 呼吸
  4: 'liver',         // 肝胆
  5: 'stomach',       // 肠胃
  6: 'kidney',        // 肾脏
  7: 'immune',        // 免疫
  8: 'vitamin',       // 维生素
  9: 'cardiovascular', // 心脑血管
  10: 'endocrine',    // 内分泌
  11: 'andrology',    // 男/妇科（根据性别区分）
  12: 'bones'         // 骨骼
}

/**
 * 指标类型编号到指标名称的映射
 */
export const INDICATOR_TYPE_NAME_MAP = {
  1: '眼部健康',
  2: '皮肤健康',
  3: '呼吸健康',
  4: '肝胆健康',
  5: '肠胃健康',
  6: '肾脏健康',
  7: '免疫健康',
  8: '维生素健康',
  9: '心脑血管健康',
  10: '内分泌健康',
  11: '男/妇科健康',
  12: '骨骼健康'
}

/**
 * 各指标类型的字段映射配置
 * 格式: { fieldKey: { name: '显示名称', indexName: '指数字段名' } }
 */
export const INDICATOR_FIELD_MAPS = {
  // 眼部 (type=1)
  eye: {
    eye1: { name: '眼轮匝肌肥厚', indexName: 'eye1Index' },
    eye2: { name: '眼皱胶原', indexName: 'eye2Index' },
    eye3: { name: '皮下色素沉着', indexName: 'eye3Index' },
    eye4: { name: '淋巴阻塞', indexName: 'eye4Index' },
    eye5: { name: '松弛下垂', indexName: 'eye5Index' },
    eye6: { name: '浮肿', indexName: 'eye6Index' },
    eye7: { name: '眼周细胞活性', indexName: 'eye7Index' },
    eye8: { name: '视力疲劳', indexName: 'eye8Index' }
  },

  // 皮肤 (type=2)
  skin: {
    skin1: { name: '皮肤自由基', indexName: 'skin1Index' },
    skin2: { name: '皮肤胶原蛋白', indexName: 'skin2Index' },
    skin3: { name: '皮肤油脂', indexName: 'skin3Index' },
    skin4: { name: '皮肤免疫', indexName: 'skin4Index' },
    skin5: { name: '皮肤水分', indexName: 'skin5Index' },
    skin6: { name: '皮肤水分流失量', indexName: 'skin6Index' },
    skin7: { name: '皮肤血红丝', indexName: 'skin7Index' },
    skin8: { name: '皮肤弹性', indexName: 'skin8Index' },
    skin9: { name: '皮肤黑色素', indexName: 'skin9Index' },
    skin10: { name: '皮肤角质', indexName: 'skin10Index' }
  },

  // 呼吸 (type=3)
  breathing: {
    vitalcapacity: { name: '肺活量', indexName: 'vitalcapacityIndex' },
    totalLungVolume: { name: '肺总量', indexName: 'totalLungVolumeIndex' },
    airwayResistance: { name: '气道阻力', indexName: 'airwayResistanceIndex' },
    arterial0xygenContent: { name: '动脉血氧含量', indexName: 'arterial0xygenContentIndex' },
    sleepBreathing: { name: '睡眠呼吸', indexName: 'sleepBreathingIndex' }
  },

  // 肝胆 (type=4)
  liver: {
    protein: { name: '蛋白质代谢', indexName: 'proteinIndex' },
    production: { name: '能量生产', indexName: 'productionIndex' },
    detoxification: { name: '解毒', indexName: 'detoxificationIndex' },
    secretion: { name: '胆汁分泌', indexName: 'secretionIndex' },
    intrahepatic: { name: '肝内脂肪含量', indexName: 'intrahepaticIndex' },
    globulin: { name: '血清球蛋白', indexName: 'globulinIndex' },
    bilirubins: { name: '总胆红素', indexName: 'bilirubinsIndex' },
    phosphatase: { name: '碱性磷酸脂酶', indexName: 'phosphataseIndex' },
    acid: { name: '血清总胆汁酸', indexName: 'acidIndex' },
    bilirubin: { name: '胆红素', indexName: 'bilirubinIndex' }
  },

  // 肠胃 (type=5)
  stomach: {
    enzyme: { name: '胃酶分泌', indexName: 'enzymeIndex' },
    peristalsis: { name: '胃蠕动', indexName: 'peristalsisIndex' },
    absorb: { name: '胃吸收', indexName: 'absorbIndex' },
    smallPeristalsis: { name: '小肠蠕动', indexName: 'smallPeristalsisIndex' },
    smallAbsorb: { name: '小肠吸收', indexName: 'smallAbsorbIndex' }
  },

  // 肾脏 (type=6)
  kidney: {
    urobilinogen: { name: '尿胆原', indexName: 'urobilinogenIndex' },
    uricAcid: { name: '尿酸', indexName: 'uricAcidIndex' },
    ureaNitrogen: { name: '尿素氮', indexName: 'ureaNitrogenIndex' },
    urineProtein: { name: '尿蛋白', indexName: 'urineProteinIndex' }
  },

  // 免疫 (type=7)
  immune: {
    immune1: { name: '淋巴结', indexName: 'immune1Index' },
    immune2: { name: '扁桃体免疫', indexName: 'immune2Index' },
    immune3: { name: '骨髓', indexName: 'immune3Index' },
    immune4: { name: '脾脏', indexName: 'immune4Index' },
    immune5: { name: '胸腺', indexName: 'immune5Index' },
    immune6: { name: '免疫球蛋白', indexName: 'immune6Index' },
    immune7: { name: '呼吸道免疫', indexName: 'immune7Index' },
    immune8: { name: '消化道免疫', indexName: 'immune8Index' },
    immune9: { name: '粘膜内免疫', indexName: 'immune9Index' }
  },

  // 维生素 (type=8)
  vitamin: {
    vitamin1: { name: '维生素A', indexName: 'vitamin1Index' },
    vitamin2: { name: '维生素B1', indexName: 'vitamin2Index' },
    vitamin3: { name: '维生素B2', indexName: 'vitamin3Index' },
    vitamin4: { name: '维生素B3', indexName: 'vitamin4Index' },
    vitamin5: { name: '维生素B6', indexName: 'vitamin5Index' },
    vitamin6: { name: '维生素B12', indexName: 'vitamin6Index' },
    vitamin7: { name: '维生素C', indexName: 'vitamin7Index' },
    vitamin8: { name: '维生素D', indexName: 'vitamin8Index' },
    vitamin9: { name: '维生素E', indexName: 'vitamin9Index' },
    vitamin10: { name: '维生素K', indexName: 'vitamin10Index' }
  },

  // 心脑血管 (type=9)
  cardiovascular: {
    blood: { name: '血液黏度', indexName: 'bloodIndex' },
    crystal: { name: '胆固醇结晶', indexName: 'crystalIndex' },
    bloodFat: { name: '血脂', indexName: 'bloodFatIndex' },
    resistance: { name: '血管阻力', indexName: 'resistanceIndex' },
    lsElasticity: { name: '血管弹性', indexName: 'lsElasticityIndex' },
    demand: { name: '心肌血液需量', indexName: 'demandIndex' },
    perfusion: { name: '心肌血液灌注量', indexName: 'perfusionIndex' },
    consumption: { name: '心肌耗氧量', indexName: 'consumptionIndex' },
    perStroke: { name: '每搏心搏出量', indexName: 'perStrokeIndex' },
    leftImpedance: { name: '左心室喷血阻抗', indexName: 'leftImpedanceIndex' },
    leftVentricle: { name: '左心室有效泵力', indexName: 'leftVentricleIndex' },
    coronaryElasticity: { name: '冠状动脉弹性', indexName: 'coronaryElasticityIndex' },
    pressure: { name: '冠状动脉灌注压', indexName: 'pressureIndex' },
    elasticity: { name: '脑血管弹性', indexName: 'elasticityIndex' },
    bloodSupply: { name: '脑组织供血', indexName: 'bloodSupplyIndex' },
    cerebralArteriosclerosis: { name: '脑动脉硬化', indexName: 'cerebralArteriosclerosisIndex' }
  },

  // 内分泌 (type=10)
  endocrine: {
    endocrine1: { name: '甲状腺', indexName: 'endocrine1Index' },
    endocrine2: { name: '甲状旁腺', indexName: 'endocrine2Index' },
    endocrine3: { name: '肾上腺', indexName: 'endocrine3Index' },
    endocrine4: { name: '脑垂体', indexName: 'endocrine4Index' },
    endocrine5: { name: '松果体', indexName: 'endocrine5Index' },
    endocrine6: { name: '胸腺分泌', indexName: 'endocrine6Index' },
    endocrine7: { name: '性腺分泌', indexName: 'endocrine7Index' },
    endocrine8: { name: '胰岛素', indexName: 'endocrine8Index' },
    endocrine9: { name: '胰高血糖素', indexName: 'endocrine9Index' },
    endocrine10: { name: '糖耐量', indexName: 'endocrine10Index' },
    endocrine11: { name: '脂质代谢', indexName: 'endocrine11Index' },
    endocrine12: { name: '褐色脂肪组织', indexName: 'endocrine12Index' }
  },

  // 男科 (type=11, sex=1)
  andrology: {
    andrology1: { name: '睾丸酮', indexName: 'andrology1Index' },
    andrology2: { name: '勃起传导', indexName: 'andrology2Index' },
    andrology3: { name: '前列腺增生', indexName: 'andrology3Index' },
    andrology4: { name: '前列腺钙化', indexName: 'andrology4Index' },
    andrology5: { name: '前列腺炎症', indexName: 'andrology5Index' }
  },

  // 妇科 (type=11, sex=2)
  female: {
    female1: { name: '雌性激素', indexName: 'female1Index' },
    female2: { name: '泌乳素', indexName: 'female2Index' },
    female3: { name: '黄体酮', indexName: 'female3Index' },
    female4: { name: '阴道炎', indexName: 'female4Index' },
    female5: { name: '盆腔炎', indexName: 'female5Index' },
    female6: { name: '附件炎', indexName: 'female6Index' },
    female7: { name: '宫颈炎', indexName: 'female7Index' },
    female8: { name: '卵巢囊肿', indexName: 'female8Index' },
    female9: { name: '乳腺增生', indexName: 'female9Index' },
    female10: { name: '急性乳腺炎', indexName: 'female10Index' },
    female11: { name: '慢性乳腺炎', indexName: 'female11Index' },
    female12: { name: '内分泌失调', indexName: 'female12Index' }
  },

  // 骨骼 (type=12)
  bones: {
    bones1: { name: '钙流失量', indexName: 'bones1Index' },
    bones2: { name: '骨质增生', indexName: 'bones2Index' },
    bones3: { name: '骨质疏松', indexName: 'bones3Index' },
    bones4: { name: '骨密度', indexName: 'bones4Index' },
    bones5: { name: '颈椎钙化', indexName: 'bones5Index' },
    bones6: { name: '腰椎钙化', indexName: 'bones6Index' },
    bones7: { name: '风湿', indexName: 'bones7Index' },
    bones8: { name: '骨源碱性磷酸酶', indexName: 'bones8Index' },
    bones9: { name: '骨钙素', indexName: 'bones9Index' },
    bones10: { name: '长骨愈合状况', indexName: 'bones10Index' },
    bones11: { name: '短骨愈合状况', indexName: 'bones11Index' },
    bones12: { name: '骨骺线', indexName: 'bones12Index' }
  }
}

/**
 * 根据类型编号和性别获取指标类型名称
 * @param {number} typeNumber - 类型编号 (1-12)
 * @param {number} sex - 性别 (1=男, 2=女, 仅 type=11 时需要)
 * @returns {string} 指标类型名称
 */
export function getIndicatorType(typeNumber, sex = 0) {
  if (typeNumber === 11) {
    // 男/妇科需要根据性别区分
    return sex === 1 ? 'andrology' : 'female'
  }
  return INDICATOR_TYPE_NUMBER_MAP[typeNumber] || null
}

/**
 * 根据类型编号获取指标名称
 * @param {number} typeNumber - 类型编号 (1-12)
 * @returns {string} 指标名称
 */
export function getIndicatorName(typeNumber) {
  return INDICATOR_TYPE_NAME_MAP[typeNumber] || '未知指标'
}

/**
 * 根据指标类型和原始数据，转换为标准格式
 * @param {string} indicatorType - 指标类型 (eye, skin, liver 等)
 * @param {Object} rawData - 原始 API 返回数据
 * @returns {Array} 转换后的数据数组 [{ name, value, index, description }]
 */
export function transformIndicatorData(indicatorType, rawData) {
  if (!rawData || !INDICATOR_FIELD_MAPS[indicatorType]) {
    return []
  }

  const fieldMap = INDICATOR_FIELD_MAPS[indicatorType]
  const result = []

  // 特殊处理：眼部数据需要从 eye1, eye2... 等字段提取
  if (indicatorType === 'eye') {
    Object.keys(rawData).forEach(key => {
      // 排除非数据字段
      if (['createTime', 'id', 'userId'].includes(key)) return

      // 匹配 eye1, eye2 等格式
      const match = key.match(/^eye(\d+)$/)
      if (match) {
        const index = parseInt(match[1])
        const fieldKey = `eye${index}`
        const field = fieldMap[fieldKey]
        const indexKey = `${key}Index`

        if (field && rawData[indexKey] !== undefined) {
          result.push({
            name: field.name,
            value: rawData[key],
            index: rawData[indexKey],
            description: field.indexName
          })
        }
      }
    })
  } else {
    // 其他类型直接使用字段映射
    Object.keys(fieldMap).forEach(fieldKey => {
      const field = fieldMap[fieldKey]
      const indexKey = field.indexName

      if (rawData[fieldKey] !== undefined && rawData[indexKey] !== undefined) {
        result.push({
          name: field.name,
          value: rawData[fieldKey],
          index: rawData[indexKey],
          description: field.indexName
        })
      }
    })
  }

  return result
}

